import * as React from 'react';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { ToneRowOptionsPrivilage, ToneRowOptionsPrivilageImpl } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { ListViewModelImpl } from '../../../../toolkit/horizontallist/listviewmodel';
import { ToneCardCSSStyle, ToneCardCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ToneEvenCardCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/toneevencardcssstyle';
import { ToneCardComponent } from '../../featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { SearchListToneCardPlayerCSSStyleImpl } from '../../searchlist/searchlisttonecardplayercss';
import { ToneMobileCardPlayerCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonemobilecardplayercss';
import { ToneCardPlayerCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardplayercss';

export class TunesToneRowOptionsPrivilageImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setTellAFriend(true);
        this.setLike(false);
        this.setAction(true);
        this.setGift(true);
        this.setBuy(false);
        this.setShare(true);
        this.setDelete(true);
        this.setSettings(true);
    }
}

export class TunesToneViewModelImpl extends ListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private audioPlayerWithProgress: AudioPlayerWithProgress;
    private toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
    private playerCSSStyle: SearchListToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;

    constructor(context: BaseContext, private onDelete: any, private onTunesSettings: any, private marginTop: string)
    {
        super(context);

        this.toneOddCardCSSStyle = new ToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ToneEvenCardCSSStyleImpl(context);
        this.toneRowOptionsPrivilage = new TunesToneRowOptionsPrivilageImpl();
        this.playerCSSStyle = new SearchListToneCardPlayerCSSStyleImpl(context);
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onTuneSettingsSelected = this.onTuneSettingsSelected.bind(this);

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={this.onDeleteClicked} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onTuneSettingsSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={this.onDeleteClicked} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onTuneSettingsSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    onDeleteClicked(toneDto: ToneDto): void 
    {
        this.onDelete(toneDto);
    }

    onTuneSettingsSelected(toneDto: ToneDto): void 
    {
        this.onTunesSettings(toneDto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunes/tones/tunestoneviewmodel.tsx